/**
 * Handle Route redirection.
 *
 * Since the Router is decoupled from Vue we can have this
 * service where the router API can be called directly.
 */
class Redirect {
    /**
     * Initialise with a `router` instance.
     */
    init(routerInstance) {
        this.router = routerInstance
    }

    /**
     * Go to named route with params e.g. {id: 9087, patientJourneyId: 15693}
     */
    /** @deprecated. Use goTo() instead. goTo() more flexible and allow to redirect with name */
    gotoPageWithParams(name, paramsObj = {}, query = {}) {
        return this.router.push({ name, params: paramsObj, query })
    }

    /**
     * Go to named route
     */
    /** @deprecated. Use goTo() instead. goTo() more flexible and allow to redirect with name */
    gotoName(name, to = undefined, query = {}) {
        return this.router.push({ name, params: { redirect: to }, query })
    }

    /**
     * Go to path route
     */
    /** @deprecated. Use goTo() instead. goTo() more flexible and allow to redirect with name */
    gotoPath(path, params = {}, query = {}) {
        return this.router.push({ path, params, query })
    }

    goTo({ name = undefined, path = undefined, params = undefined, query = undefined }) {
        return this.router.push({ name, path, params, query })
    }

    /**
     * Go to named route with full page reload (HTTP redirect).
     * @param {string} name - Route name.
     */
    goToWithReload({ name, path, params, query }) {
        const route = this.router.resolve({ name, path, params, query })
        window.location.href = route.href
    }

    /**
     * Go to PatientListPage or PatientJourneyListPage, according to owner config.
     */
    gotoPatientListPageForOwner(owner) {
        const name = owner.hasPatientJourneyList ? 'PatientJourneyList' : 'PatientList'
        this.gotoName(name)
    }

    /**
     * Replace current with path route
     */

    /** @deprecated Use replace() instead. replace() more flexible and allow to redirect with name */
    replacePath(path) {
        return this.router.replace({ path: path })
    }

    replace({ name, path, params, query }) {
        return this.router.replace({ path, name, params, query })
    }

    /**
     * Get params / query for the existing route
     */
    /** @deprecated. Use goTo() instead. goTo() more flexible and allow to redirect with name */
    getParamsQuery(params, query = {}) {
        return this.router.push({ params, query })
    }

    /**
     * Set query params for the current route, forces replace if passed same query.
     * @param queryParams
     */
    setQueryParams(queryParams) {
        const updatedQuery = {
            ...this.router.currentRoute.value.query,
            ...queryParams
        }

        this.router.replace({
            path: this.router.currentRoute.value.path,
            query: updatedQuery
        })
    }
}

export default new Redirect()
